<template>
    <div :style="{backgroundColor:layout?.pageBackground?.color}">
        <section class="innovation-section" v-if="layout">
            <div class="container">
                <div class="row">
                    <div class="block-title-w" v-html="layout.box1?.messageContent?.text"></div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "PageLayoutNine",
    props: {
        layout: Object
    }
}
</script>